import { type ReactNode, useState } from 'react';

import { NofomoLoyaltyStoreContext } from './context';
import {
  createLoyaltyStore,
  initNofomoLoyaltyStore,
  type NofomoLoyaltyStoreReturnType,
} from './zustand';

interface LoyaltyStoreProviderProps {
  children: ReactNode;
}

export const LoyaltyStoreProvider = ({
  children,
}: LoyaltyStoreProviderProps) => {
  const [store] = useState<NofomoLoyaltyStoreReturnType>(() =>
    createLoyaltyStore(initNofomoLoyaltyStore({})),
  );

  return (
    <NofomoLoyaltyStoreContext.Provider value={store}>
      {children}
    </NofomoLoyaltyStoreContext.Provider>
  );
};
